import { render, staticRenderFns } from "./parent-page.vue?vue&type=template&id=8b93588e&"
import script from "./parent-page.vue?vue&type=script&lang=ts&"
export * from "./parent-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports